import { IconButton, styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  wrapper: {
    "& .MuiDrawer-paper": {
      background: "transparent",
      boxShadow: "none",
      display: "flex",
      flexDirection: "column",
      width: "calc(100% - 16px)",

      "& > section": {
        height: "100%",
      },

      "@media (min-width: 1024px)": {
        height: "calc(100% - 30px)",
      },
      "@media (min-width: 768px)": {
        borderRadius: "8px",
        width: "400px",
        margin: "15px 15px 15px 0",
      },
    },
  },
}));

export const ComponentSection = styled("section")(() => ({
  background: colors.white,
  overflowY: "auto",
}));

export const ComponentItem = styled("div")(() => ({
  padding: "24px 34px 24px 24px",
}));

export const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));

export const Content = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const MileStonesHeader = styled("header")(() => ({
  borderRadius: "8px 8px 0 0",
  height: 82,
  padding: "1rem 2rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const MileStonesDesktopHeader = styled(MileStonesHeader)(() => ({
  background: colors.brandBlue50,
}));

export const MileStonesMobileHeader = styled(MileStonesHeader)(() => ({
  background: colors.gray50,
  justifyContent: "flex-start",
}));

export const MileStonesTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "20px",
  fontWeight: 600,
  lineHeight: "28px",
  padding: "16px 12px 16px 24px",
}));

export const MileStonesDesktopTitle = styled(MileStonesTitle)(() => ({
  color: colors.brandBlue500,
  padding: "0",
}));

export const MileStonesMobileTitle = styled(MileStonesTitle)(() => ({
  color: colors.gray800,
}));

export const MileStonesIconButton = styled(IconButton)(() => ({
  width: "24px",
  height: "24px",
  fontSize: "16px",
  padding: "0px !important",

  "& > span": {
    "& > div": {
      "& > svg": {
        transform: "rotate(180deg)",
      },
    },
  },
}));
export const MileStonesMobileIconButton = styled(MileStonesIconButton)(() => ({
  background: "transparent",
}));

export default styles;
